//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Jones',
  data() {
    return {
      form:{
        carditis:'0',
        arthritis:'0',
        chorea:'0',
        nodules:'0',
        marginatum:'0',
        fever:'0',
        arthralgia:'0',
        crp:'0',
        int:'0',
        prev:'0',
        strep:'0'
      },
      hasScore:false,
      disabled:false,
      defaultJson:{
        "Polyarthritis": "多关节炎",
        "Previous rheumatic heart disease or rheumatic nodules": "既往风湿性心脏病或风湿热病史",
        "Erythema marginatum": "边缘性红斑",
        "evidenceHint": "近期 A 组链球菌感染证据：\n • 抗链球菌溶血素 O 抗体或其他链球菌抗体升高\n • 咽拭子培养 A 组 β-溶血性链球菌阳性\n • 快速直接 A 组链球菌糖类抗原试验阳性\n • 近期患猩红热",
        "nodules": "发热",
        "Arthralgia": "关节痛",
        "feverHint": "38.2 - 38.9 °C\n101 - 102 °F",
        "ARF is probable": "ARF 可能",
        "ARF is improbable": "ARF 不可能",
        "arthritisHint": "游走性关节炎，主要累及膝关节、踝关节、肘关节和腕关节等。",
        "choreaHint": "突然发作的、无目的的活动。这可以是 ARF 仅有的临床表现，并且具有诊断意义。",
        "Prolonged PR interval": "PR 间期延长",
        "Sydenham's Chorea": "Sydenham 舞蹈征",
        "Evidence of infection": "感染证据",
        "Major criteria": "主要标准",
        "Minor criteria": "次要标准",
        "%@ Minor Criteria": "%@ 条次要标准",
        "Evidence of streptococcal infection": "链球菌感染证据",
        "Subcutaneous nodules": "皮下结节",
        "Carditis": "心肌炎",
        "1 Major Criterion": "1 条主要标准",
        "Elevated acute-phase reactants": "急性期反应物升高",
        "1 Minor Criterion": "1 条次要标准",
        "crpHint": "血沉（ESR）、C-反应蛋白（CRP）及白细胞等升高",
        "%@ Major Criteria": "%@ 条主要标准"
      },
      major:0,
      minor:0
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      // strep  ?  ((major >= 2) ? 1  :  ((major >= 1) ? ((minor >= 2) ? 1 : 0) : 0)) : 0
      let result =  self.form.strep  ?  ((self.major >= 2) ? 1  :  ((self.major >= 1) ? ((self.minor >= 2) ? 1 : 0) : 0)) : 0
      self.hasScore = true
      console.log(result,11);
      return String(result)

      // major > 1 ? 2 : (major > 0 ? (minor > 2 ? 2 : (minor > 0 ? 1 : 0)) : (minor > 4 ? 2 : (minor > 2 ? 1 : 0)))
    },
    /** 计算主要标准 */
    score1() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      // carditis + arthritis  + chorea  + nodules  + marginatum
      let result = form.carditis + form.arthritis  + form.chorea  + form.nodules  + form.marginatum
      self.major = String(result)
      return String(result)
    },
    /** 计算次要标准 */
    score2() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      // fever + arthralgia  + crp  + int  + prev
      let result = form.fever + form.arthralgia  + form.crp  + form.int  + form.prev
      self.minor = String(result)
      return String(result)
    },
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/Jones.vue